<template>
    <div class="paging">
        <a
            v-if="currentPage !== 1"
            class="prev"
            href="/"
            @click.prevent="setPage(currentPage - 1)"
        >« Previous</a>
        <span class="pages">
            <a
                href="/"
                v-show="lastPage >= 1"
                :class="{ active: currentPage === 1 }"
                @click.prevent="setPage(1)"
            >1</a>
            <a
                v-show="currentPage >= 5"
                class="page-separator"
                aria-disabled="true"
            >...</a>
            <a
                v-for="page in lastPage - 2"
                :key="page + 1"
                :class="{ active: page + 1 === currentPage }"
                href="/"
                v-show="(currentPage <= 4 && page <= 5)
                    || (currentPage >= lastPage - 3 && page >= lastPage - 6)
                    || (currentPage >= page - 1 && currentPage <= page + 3)"
                @click.prevent="setPage(page + 1)"
            >{{ page + 1 }}</a>
            <a
                v-show="currentPage <= lastPage - 4"
                class="page-separator"
                aria-disabled="true"
            >...</a>
            <a
                href="/"
                v-show="lastPage >= 2"
                :class="{ active: currentPage === lastPage }"
                @click.prevent="setPage(lastPage)"
            >{{ lastPage }}</a>
        </span>
        <a
            v-if="currentPage !== lastPage"
            class="next"
            href="/"
            @click.prevent="setPage(currentPage + 1)"
        >Next »</a>
    </div>
</template>

<script>
export default {
    props: ["currentPage", "lastPage"],
    emits: ["navigate"],
    methods: {
        setPage(page) {
            window.scroll({ top: 0 });
            this.$emit("navigate", page);
        },
    },
}
</script>

<style scoped>
.paging .pages a {
    margin: 0;
}
.paging .pages .page-separator {
    user-select: none;
    pointer-events: none;
}
</style>
